import { createSlice,createAsyncThunk } from "@reduxjs/toolkit"
import axios from "axios"
import {BASE_URL} from '../../utils/commonUrl'
const initState = {
    isLoading:false,
    message:'',
    userRoleNames:[]
}

export const fetchUserRoleName = createAsyncThunk('userRoleName/getall', async () => {
    const response = await axios.get(`${BASE_URL}/api/userRoleName`)
    return response.data
  })


let userSlice = createSlice({
  name:'userRoleName',
  initialState:initState,
  extraReducers:(builder)=>{
      builder
      .addCase(fetchUserRoleName.pending,(state)=>{
          state.isLoading = true
      })
      .addCase(fetchUserRoleName.fulfilled,(state,action)=>{
          state.isLoading = false
          state.userRoleNames = action.payload
      })
      .addCase(fetchUserRoleName.rejected,(state,payload)=>{
          state.isLoading = false
          state.message = payload.data.message
      })

  },
  reducers:{
      
  
  }
})

//export const {} = userSlice.actions;

export default userSlice.reducer;